import {
  AlertDialogModel,
  ToastViewModel,
} from 'src/app/core/models/view-model';
import { NavigationExtras, Router } from '@angular/router';
import { UserProfile } from 'src/app/core/models/user';
import { HttpErrorResponse } from '@angular/common/http';
import { Role } from 'src/app/core/models/user-management/role';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { MasterHelper } from './../../../core/utilities/master-helper';
import { DeleteDialogComponent } from '../../distributed-ui-components';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { CommonService } from './../../../core/services/common/common.service';
import { ImpactService } from './../../../core/services/impact/impact.service';
import { ItemActiveModel } from 'src/app/core/models/view-model/item-acive-model';
import { DeleteItemModel } from 'src/app/core/models/filter-model/delete-item-model';
import { DownloadReportModel } from 'src/app/core/models/view-model/download-report-model';
import { BulkUpdateModel } from './../../../core/models/impact-assessment/bulk-update-model';
import { ImpactAssessment } from './../../../core/models/impact-assessment/impact-assessment';
import { BulkUpdateDialogComponent } from './../bulk-update-dialog/bulk-update-dialog.component';
import { ImpactAssessmentListDto } from 'src/app/core/models/impact-assessment/impact-assessment-list';
import { ImpactAssessmentFilter } from 'src/app/core/models/impact-assessment/impact-assessment-filter';
import { ImpactAssessmentColumnModel, ImpactAssessmentColumnModelT6 } from 'src/app/core/models/view-model/impact-assessment-column-model';
import { ImpactAssessmentViewModel } from 'src/app/core/models/impact-assessment/impact-assessment-view-model';
import { MatDialog } from '@angular/material/dialog';
import { GDPRService } from 'src/app/core/services/rulebook';
import { ImpactAssessmentFilterT4 } from 'src/app/core/models/impact-assessment/impact-assessmentT4-filter';
import { ImpactAssessmentT4ListDto } from 'src/app/core/models/impact-assessment/impact-assessmentT4-list';
import { ImpactAssessmentT4ColumnModel } from 'src/app/core/models/view-model/impact-assessmentT4-column-model';
import { ImpactAssessmentT4ViewModel } from 'src/app/core/models/impact-assessment/impact-assessmentT4-view-model';
import { BulkUpdateT4Model } from 'src/app/core/models/impact-assessment/bulk-updateT4-model';
import { BulkUpdateT4DialogComponent } from '../bulk-update-t4-dialog/bulk-update-t4-dialog.component';
import { ImpactAssessment4 } from 'src/app/core/models/impact-assessment/impact-assessment4';

import { BulkUpdateT5Model, ImpactAssessmentT5, ImpactAssessmentT5ColumnModel, ImpactAssessmentT5Filter, ImpactAssessmentT5ViewModel } from 'src/app/core/models/impact-assessment/impact-assessmentT5';
import { BulkUpdateDialogT5Component } from '../bulk-update-dialog-t5/bulk-update-dialog-t5.component';
import { GlobalService } from 'src/app/core/services/global/global.service';

import { ImpactAssessmentT6ListDto } from 'src/app/core/models/impact-assessment/impact-assessmentT6-list';

import { ImpactAssessmentFilterT6 } from 'src/app/core/models/impact-assessment/ImpactAssessmentFilterT6';
import { GeneralDataService } from 'src/app/core/services/general/general-data.service';

@Component({
  selector: 'app-impact-assessment-summary',
  templateUrl: './impact-assessment-summary.component.html',
  styleUrls: ['./impact-assessment-summary.component.scss'],
})
export class ImpactAssessmentSummaryComponent implements OnInit {
  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;

  impactAssessmentSummary: Array<ImpactAssessmentListDto>;
  impactAssessmentT4Summary: Array<ImpactAssessmentT4ListDto>;
  impactAssessmentT5Summary: Array<ImpactAssessmentT5>;
  impactAssessmentT6Summary: Array<ImpactAssessmentT6ListDto>;
  selectedItems: Array<number>;
  updatedDbIds: Array<number>;
  toastModel: ToastViewModel;
  isToastShow = false;
  alertDialogModel: AlertDialogModel;
  impactAssessmentFilter: ImpactAssessmentFilter;
  impactAssessmentT4Filter: ImpactAssessmentFilterT4;
  impactAssessmentT5Filter: ImpactAssessmentT5Filter;
  impactAssessmentT6Filter: ImpactAssessmentFilterT6;
  totalCount = 0;
  isTableLoaded = false;
  isLoading = false;
  newIAItemId: number;
  myInnerHeight: any;
  endIndex = 0;
  selectedItemId = 0;
  userAccessToken: UserProfile;
  currentUserRole = '';
  bulkUpdateModel: BulkUpdateModel;
  bulkUpdateT4Model: BulkUpdateT4Model;
  bulkUpdateT5Model: BulkUpdateT5Model;
  downloadReportModel: DownloadReportModel;
  authenticatedItems: Array<number>;
  dCode = '';
  buCode = '';
  erCode = '';
  itemActiveModel: Array<ItemActiveModel>;
  itemActiveModelT4: Array<ItemActiveModel>;
  itemActiveModelT5: Array<ItemActiveModel>; // Ekhan theke shuru korbo
  itemActiveT6Model: Array<ItemActiveModel>;
  impactAssessmentColumns: ImpactAssessmentColumnModel;
  impactAssessmentT4Columns: ImpactAssessmentT4ColumnModel;
  impactAssessmentT5Columns: ImpactAssessmentT5ColumnModel;
  impactAssessmentT6Columns: ImpactAssessmentColumnModelT6
  tableWidth!: number;
  assesmentType = '_iacol';
  templateNo = 0;
  selectedJuris: Array<string>;
  idList:number[]=[];
  constructor(
    private impactService: ImpactService,
    private gdprService: GDPRService,
    private sessionService: SessionService,
    private eleRef: ElementRef,
    public dialog: MatDialog,
    private router: Router,
    public commonService: CommonService,
    private ref: ChangeDetectorRef,
    public _globalService: GlobalService,
    private generalService: GeneralDataService
  ) {
    this.myInnerHeight = window.innerHeight - 200;
    this.impactAssessmentSummary = [];
    this.impactAssessmentT4Summary = [];
    this.impactAssessmentT5Summary = [];
    this.impactAssessmentT6Summary = [];
    this.selectedItems = [];
    this.updatedDbIds = [];
    this.userAccessToken = new UserProfile();
    this.toastModel = new ToastViewModel();
    this.alertDialogModel = new AlertDialogModel();
    this.impactAssessmentFilter = new ImpactAssessmentFilter();
    this.impactAssessmentT4Filter = new ImpactAssessmentFilterT4();
    this.impactAssessmentT5Filter = new ImpactAssessmentT5Filter();
    this.impactAssessmentT6Filter = new ImpactAssessmentFilterT6;
    this.impactService.detailTabActive = false;
    this.authenticatedItems = [];
    this.selectedJuris = [];
    this.impactAssessmentColumns = new ImpactAssessmentColumnModel();
    this.impactAssessmentT4Columns = new ImpactAssessmentT4ColumnModel();
    this.impactAssessmentT5Columns = new ImpactAssessmentT5ColumnModel();
    this.impactAssessmentT6Columns = new ImpactAssessmentColumnModelT6();
    this.newIAItemId = this.fetchFromBrowser('_iaid')
      ? Number(this.fetchFromBrowser('_iaid'))
      : 0;
    if (this.newIAItemId > 0) {
      this.selectedItems.push(this.newIAItemId);
    }
    this.bulkUpdateModel = new BulkUpdateModel();

    this.bulkUpdateT4Model = new BulkUpdateT4Model();
    this.bulkUpdateT5Model = new BulkUpdateT5Model();
    this.downloadReportModel = new DownloadReportModel();
    const presistFilterT4 = JSON.parse(this.fetchFromBrowser('impactAssessmentFiltersT4') as string) as ImpactAssessmentFilterT4;
    const presistFilterT6 = JSON.parse(this.fetchFromBrowser('impactAssessmentFiltersT6') as string) as ImpactAssessmentFilterT6;
    if (presistFilterT4) {
      this.impactAssessmentT4Filter = presistFilterT4;
    }
    if(presistFilterT6){
      this.impactAssessmentT6Filter = presistFilterT6;
    }
    const persistFilter = JSON.parse(
      this.fetchFromBrowser('impactAssessmentFilters') as string
    ) as ImpactAssessmentFilter;
    if (persistFilter) {
      this.impactAssessmentFilter = persistFilter;
    }
    this.itemActiveT6Model = [
      { itemTitle: 'Regulator', itemWidth: 120, isActive: true },
      { itemTitle: 'Title', itemWidth: 300, isActive: true },
      { itemTitle: 'Topic', itemWidth: 120, isActive: true },
      { itemTitle: 'Publish Date', itemWidth: 150, isActive: true },
      { itemTitle: 'Rule Type', itemWidth: 120, isActive: true },
      { itemTitle: 'Effective Date', itemWidth: 190, isActive: true },
      { itemTitle: 'Impact Rating', itemWidth: 120, isActive: true },
      { itemTitle: 'Assessment Team', itemWidth: 190, isActive: true },
      { itemTitle: 'Assessor', itemWidth: 120, isActive: true },

    ];
    this.itemActiveModel = [
      { itemTitle: 'Regulator', itemWidth: 120, isActive: true },
      { itemTitle: 'Title', itemWidth: 300, isActive: true },
      { itemTitle: 'Topic', itemWidth: 120, isActive: true },
      { itemTitle: 'Publish Date', itemWidth: 150, isActive: true },
      { itemTitle: 'Rule Type', itemWidth: 120, isActive: true },
      { itemTitle: 'Effective Date', itemWidth: 190, isActive: true },
      { itemTitle: 'Legal Entity', itemWidth: 120, isActive: true },
      { itemTitle: 'Jurisdiction', itemWidth: 120, isActive: true },
      { itemTitle: 'Impact Rating', itemWidth: 120, isActive: true },
      { itemTitle: 'Implementation Type', itemWidth: 190, isActive: true },
      { itemTitle: 'Assessment Team', itemWidth: 190, isActive: true },
      { itemTitle: 'Assessor', itemWidth: 120, isActive: true },
      { itemTitle: 'Review Team', itemWidth: 150, isActive: true },
      { itemTitle: 'Reviewer', itemWidth: 120, isActive: true },
      { itemTitle: 'Implementation Team', itemWidth: 190, isActive: true },
      { itemTitle: 'Implementation Owner', itemWidth: 190, isActive: true },
      { itemTitle: 'Assessment Status', itemWidth: 190, isActive: true },
      { itemTitle: 'Review Status', itemWidth: 150, isActive: true },
      { itemTitle: 'Implementation Status', itemWidth: 190, isActive: true },
    ];
    this.itemActiveModelT4 = [
      { itemTitle: 'Regulator', itemWidth: 120, isActive: true },
      { itemTitle: 'Title', itemWidth: 300, isActive: true },
      { itemTitle: 'Topic', itemWidth: 120, isActive: true },
      { itemTitle: 'Publish Date', itemWidth: 150, isActive: true },
      { itemTitle: 'Rule Type', itemWidth: 120, isActive: true },
      { itemTitle: 'Effective Date', itemWidth: 190, isActive: true },
      { itemTitle: 'Last Update', itemWidth: 120, isActive: true },
      { itemTitle: 'Jurisdiction', itemWidth: 120, isActive: true },
      { itemTitle: 'Assessor', itemWidth: 120, isActive: true },
      { itemTitle: 'Assessment Status', itemWidth: 190, isActive: true }
    ];
    this.itemActiveModelT5 = [
      { itemTitle: 'Regulator', itemWidth: 120, isActive: true },
      { itemTitle: 'Title', itemWidth: 300, isActive: true },
      { itemTitle: 'Topic', itemWidth: 300, isActive: true },
      { itemTitle: 'Team', itemWidth: 150, isActive: true },
      { itemTitle: 'Rule Type', itemWidth: 120, isActive: true },
      { itemTitle: 'Effective Date', itemWidth: 190, isActive: true },
      { itemTitle: 'Response Lead', itemWidth: 190, isActive: true },
      { itemTitle: 'Jurisdiction', itemWidth: 120, isActive: true },
      { itemTitle: 'Accountable Executive', itemWidth: 190, isActive: true },
      { itemTitle: 'Rag Rating', itemWidth: 120, isActive: true },
      { itemTitle: 'Response Deadline', itemWidth: 150, isActive: true },
      { itemTitle: 'Consultation Period', itemWidth: 150, isActive: true },
      { itemTitle: 'Did We Respond', itemWidth: 120, isActive: true },
      { itemTitle: 'Response Appraoch', itemWidth: 150, isActive: true },
      { itemTitle: 'Report Submission Date', itemWidth: 150, isActive: true },
      { itemTitle: 'Extension Requested', itemWidth: 150, isActive: true },
      { itemTitle: 'Current Status', itemWidth: 150, isActive: true },
      { itemTitle: 'Next Action Date', itemWidth: 150, isActive: true },
      { itemTitle: 'Engagement Plan', itemWidth: 150, isActive: true },
      { itemTitle: 'Policy Response Achieved', itemWidth: 190, isActive: true },
      { itemTitle: 'No. of Key Messages', itemWidth: 150, isActive: true },
      { itemTitle: 'Key Messages Acheived', itemWidth: 150, isActive: true }
    ];
  }

  async ngOnInit(): Promise<void> {
    let result: UserProfile = await this.sessionService.getLoginUserInfo().toPromise();
    this.userAccessToken = result;

    const persistColumn = JSON.parse(
      this.fetchFromBrowser(this.assesmentType) as string
    ) as ItemActiveModel[];
    if (persistColumn) {
      this.itemActiveModel = persistColumn;
    }
    const persistColumnT4 = JSON.parse(this.fetchFromBrowser(this.assesmentType) as string) as ItemActiveModel[];
    if (persistColumnT4) {
      this.itemActiveModelT4 = persistColumnT4;
    }
    //For Template 5
    const persistColumnT5 = JSON.parse(this.fetchFromBrowser(this.assesmentType) as string) as ItemActiveModel[];
    if (persistColumnT5) {
      this.itemActiveModelT5 = persistColumnT5;
    }
    //For Template 6
    const persistColumnT6 = JSON.parse(this.fetchFromBrowser(this.assesmentType) as string) as ItemActiveModel[];
    if (persistColumnT6) {
      this.itemActiveT6Model = persistColumnT6;
    }

    if (this.router.url === '/impact-assessment/complete') {
      this.impactAssessmentColumns.assessmentDueDate = false;
      this.impactAssessmentColumns.reviewDueDate = false;
      this.impactAssessmentColumns.implementationDueDate = false;
      this.tableWidth = +this.tableWidth - 570;
      this.removeItemFromArray('Next Action Date');
      this.removeItemFromArray('Review Due Date');
      this.removeItemFromArray('Implementation Due Date');
    } else {
      if (this.itemActiveModel.findIndex(a => a.itemTitle === 'Next Action Date') < 0) {
        this.itemActiveModel.push({ itemTitle: 'Next Action Date', itemWidth: 190, isActive: true });
      }
      if (this.itemActiveModel.findIndex(a => a.itemTitle === 'Review Due Date') < 0) {
        this.itemActiveModel.push({ itemTitle: 'Review Due Date', itemWidth: 190, isActive: true });
      }
      if (this.itemActiveModel.findIndex(a => a.itemTitle === 'Implementation Due Date') < 0) {
        this.itemActiveModel.push({ itemTitle: 'Implementation Due Date', itemWidth: 190, isActive: true });
      }
    }
    if (this.templateNo == 5 || this.templateNo == 6) {
      const bodyStyleElement = document.querySelector('.body-style5') as HTMLDivElement;
      const tableElement = document.querySelector('.table') as HTMLDivElement;

      // Check if the elements exist
      if (bodyStyleElement && tableElement) {
        // Set the width for .body-style and .table
        bodyStyleElement.style.width = this.tableWidth + 'px';
        tableElement.style.width = this.tableWidth + 'px';
        bodyStyleElement.style.overflow = 'auto';
      }
    }

    this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
    this.itemActiveModel.forEach((element) => {
      this.showHideColumn(element.itemTitle, element.itemWidth, element.isActive, 'OnLoad');
    });
    this.itemActiveModelT4.forEach((element) => {
      this.showHideColumnT4(element.itemTitle, element.itemWidth, element.isActive, 'OnLoad');
    });
    this.itemActiveModelT5.forEach((element) => {
      this.showHideColumnT5(element.itemTitle, element.itemWidth, element.isActive, 'OnLoad');
    });
    this.itemActiveT6Model.forEach((element) => {
      this.showHideColumnT6(element.itemTitle, element.itemWidth, element.isActive, 'OnLoad');
    });
    this.fetchCurrentUserRole();
    this.impactAssessmentFilter.SortKey = 'Id';
    this.impactAssessmentFilter.IsDesc = true;
    this.impactAssessmentT4Filter.SortKey = 'Id';
    this.impactAssessmentT4Filter.IsDesc = true;
    this.impactAssessmentT5Filter.SortKey = 'Id';
    this.impactAssessmentT5Filter.IsDesc = true;
    this.impactAssessmentT6Filter.SortKey = 'Id';
    this.impactAssessmentT6Filter.IsDesc = true;
    this.getActionCode();
    this.fetchImpactAssessmentSummary();
    this.removeFromBrowser('_iaid');
    this.generalService.getDivisionSelected().subscribe(async res => {
      this.fetchImpactAssessmentSummary();
    })

  }

  handler(): void {
    this.endIndex = this.viewport.getRenderedRange().end;
    if ((this.endIndex % 30) === 0 && (this.endIndex / 30) === this.impactAssessmentT6Filter.Page) {
      this.impactAssessmentT6Filter.Page = this.impactAssessmentT5Filter.page + 1;
      this.fetchImpactAssessmentSummary();
    }
  }

  removeItemFromArray(title: string): void {
    this.itemActiveModel.forEach((item, index) => {
      if (item.itemTitle === title) {
        this.itemActiveModel.splice(index, 1);
      }
    });
  }

  fetchCurrentUserRole(): void {
    this.impactService.getCurrentUserRole().subscribe((data: Role) => {
      this.currentUserRole = data.title;
    });
  }

  getActionCode(): void {
    const url = this.router.url;
    this.dCode = url === '/impact-assessment/summary' ? 'IAD' : 'CAD';
    this.buCode = url === '/impact-assessment/summary' ? 'IABU' : 'CABU';
    this.erCode = url === '/impact-assessment/summary' ? 'IAER' : 'CAER';
  }

  fetchImpactAssessmentSummary(): void {

    this.isLoading = true;
    const url = this.router.url;
    this.gdprService.getTemplateNo().subscribe((data: any) => {
      this.templateNo = data.result;
      //New Template 5 work
      if (this.templateNo == 5) {
        if (this.impactAssessmentT5Filter.jurisdiction.length == 0) {
          this.impactAssessmentT5Filter.jurisdiction.push(this.userAccessToken?.lastUsedJurisdictionName.toString())
          this.saveOnBrowser(this.filterPersistenceKeyT5, JSON.stringify(this.impactAssessmentT5Filter));
        }
        this.impactAssessmentT5Filter.filterType = url === '/impact-assessment/summary' ? 'InProgress' : 'Complete';
        this.impactService
          .getImpactAssessmentT5(this.impactAssessmentT5Filter)
          .subscribe((result: ImpactAssessmentT5ViewModel) => {
            this.impactAssessmentT5Summary = this.impactAssessmentT5Filter.page > 1 ? this.impactAssessmentT5Summary.concat(result.data) : result.data;
            this.totalCount = result.totalCount;
            this.isLoading = false;
            this.isTableLoaded = true;
            this.endIndex =
              this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
            this.templateNo = result.templateNo;
            this.ref.detectChanges();
            this.tableWidth = 3900;
            this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
            this.idList= this.getT5IdList();
          });
      }
      else if (this.templateNo == 4) {
        this.impactAssessmentT4Filter.filterType = url === '/impact-assessment/summary' ? 'InProgress' : 'Complete';
        this.impactService
          .getImpactAssessmentT4(this.impactAssessmentT4Filter)
          .subscribe((result: ImpactAssessmentT4ViewModel) => {
            this.impactAssessmentT4Summary = result.data;
            this.totalCount = result.totalCount;
            this.isLoading = false;
            this.isTableLoaded = true;
            this.endIndex =
              this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
            this.templateNo = result.templateNo;
            this.tableWidth = 2030;
            this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
            this.idList= this.getT4IdList();
          });
      }
      else if (this.templateNo == 6) {
        let fromDate = this.impactAssessmentT6Filter.fromDate 
        let toDate = this.impactAssessmentT6Filter.toDate
        if (fromDate) {
          this.impactAssessmentT6Filter.fromDate = MasterHelper.formatDate(fromDate, 'YYYY-MM-DDTHH:mm:ssZ');
        }
        if (toDate) {
          this.impactAssessmentT6Filter.toDate = MasterHelper.formatDate(toDate, 'YYYY-MM-DDTHH:mm:ssZ');
        } 
        this.impactAssessmentT6Filter.filterType =
          url === '/impact-assessment/summary' ? 'Assessment In Progress' : 'Complete';
        this.impactService.getImpactAssessmentT6(this.impactAssessmentT6Filter).subscribe((result: any) => {
          this.impactAssessmentT6Summary = this.impactAssessmentT6Filter.Page > 1 ? this.impactAssessmentT6Summary.concat(result.data) : result.data;
          //this.impactAssessmentT6Summary = result.data;
          this.totalCount = result.totalCount;
          this.isLoading = false;
          this.isTableLoaded = true;
          this.endIndex =
            this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
          this.templateNo = result.templateNo;
          this.tableWidth = 2100;
          this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
          this.idList= this.getT6IdList();
        });
      }
      else {
        this.impactAssessmentFilter.filterType =
          url === '/impact-assessment/summary' ? 'InProgress' : 'Complete';
        let fromDate = this.impactAssessmentFilter.fromDate 
        let toDate = this.impactAssessmentFilter.toDate
        if (fromDate) {
          this.impactAssessmentFilter.fromDate = MasterHelper.formatDate(fromDate, 'YYYY-MM-DDTHH:mm:ssZ');
        }
        if (toDate) {
          this.impactAssessmentFilter.toDate = MasterHelper.formatDate(toDate, 'YYYY-MM-DDTHH:mm:ssZ');
        }        

        this.impactService
          .getImpactAssessment(this.impactAssessmentFilter)
          .subscribe((result: ImpactAssessmentViewModel) => {

            this.impactAssessmentSummary = result.data;
            this.totalCount = result.totalCount;
            this.isLoading = false;
            this.isTableLoaded = true;
            this.endIndex =
              this.endIndex > this.totalCount ? this.totalCount : this.endIndex;
            this.templateNo = result.templateNo;
            if (this.templateNo == 1 || 0) {
              this.tableWidth = 4100;
            }
            //template 3 table width
            if (this.templateNo == 3) {
              this.tableWidth = 2530;
              this.removeItemFromArray('Review Status');
              this.removeItemFromArray('Review Due Date');
              this.removeItemFromArray('Implementation Due Date');
              this.removeItemFromArray('Implementation Status');
              this.removeItemFromArray('Review Team');
              this.removeItemFromArray('Reviewer');
              this.removeItemFromArray('Implementation Team');
              this.removeItemFromArray('Implementation Owner');
              this.removeItemFromArray('Assessment Team');
            }
            // template 2 table width
            if (this.templateNo == 2)
              this.tableWidth = 2550;
            this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
            this.idList= this.getIdList();
          });
          
      }
    });
  }

  sortImpactAssessment(key: string): void {
    this.impactAssessmentT6Filter.IsDesc = !this.impactAssessmentT6Filter.IsDesc;
    this.impactAssessmentT6Filter.SortKey = key;
    this.fetchImpactAssessmentSummary();
  }

  public scrollRight(): void {
    this.tableContent.nativeElement.scrollTo({
      left: this.tableContent.nativeElement.scrollLeft + 150,
      behavior: 'smooth',
    });
  }

  public scrollLeft(): void {
    this.tableContent.nativeElement.scrollTo({
      left: this.tableContent.nativeElement.scrollLeft - 150,
      behavior: 'smooth',
    });
  }

  selectItem(event: any, id: number, updatedDbId: number, jurisdiction: string): void {
    if (event === 'Checked') {
      this.selectedItems.push(id);
      this.updatedDbIds.push(updatedDbId);
      this.checkUserIAAuthentication(id);
      this.selectedJuris.push(jurisdiction);
    } else {
      const index = (this.selectedItems as number[]).indexOf(id);
      if (index >= 0) {
        (this.selectedItems as number[]).splice(index, 1);
      }
      const index2 = (this.authenticatedItems as number[]).indexOf(id);
      if (index2 >= 0) {
        (this.authenticatedItems as number[]).splice(index2, 1);
      }
      const index3 = (this.updatedDbIds as number[]).indexOf(updatedDbId);
      if (index3 >= 0) {
        (this.updatedDbIds as number[]).splice(index3, 1);
      }
      const index4 = (this.selectedJuris as string[]).indexOf(jurisdiction);
      if (index4 >= 0) {
        (this.selectedJuris as string[]).splice(index4, 1);
      }
    }
  }

  checkUserIAAuthentication(id: number): void {
    this.impactService.getIAUsers(id).subscribe((result: string[]) => {
      const isExist = result.indexOf(this.userAccessToken.fullName) >= 0 ? true : false;
      if (isExist) {
        this.authenticatedItems.push(id);
      }
    });
  }
 

  checkIAUserAuth(item: ImpactAssessmentListDto): boolean {
    const allUsers = item.assessor ? item.assessor : '' + ',' + item.assessorDelegate ? item.assessorDelegate : ''
      + ',' + item.reviewer ? item.reviewer : '' + ',' + item.reviewerDelegate ? item.reviewerDelegate : ''
        + ',' + item.implementationOwner ? item.implementationOwner : '';

    if (allUsers) {
      const userArr = allUsers.split(',');
      return userArr.some(a => (a && a.toLowerCase()) === this.userAccessToken.fullName.toLowerCase());
    } else {
      return false;
    }
  }

  deleteItem(): void {
    if (this.selectedItems.length > 0) {
      this.openDeleteDialog();
    } else {
      this.alertMessage();
    }
  }

  openDeleteDialog(): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel,
    });
    dialogRef.afterClosed().subscribe((result:any) => {

      if (result === 'Delete Item') {
        if (this.templateNo == 4) {
          this.deleteImpactAssessmentT4();
        }
        else if (this.templateNo == 5) {
          this.deleteImpactAssessmentT5();
        }
        else if (this.templateNo == 6) {
          this.deleteImpactAssessmentT6();
        }
        else {
          this.deleteImpactAssessment();
        }
      }
    });
  }
  deleteImpactAssessmentT6(): void {

    this.isLoading = true;
    const deleteItemModel = new DeleteItemModel();
    deleteItemModel.itemId = this.selectedItems;
    deleteItemModel.updatedDbId = this.updatedDbIds;
    deleteItemModel.screenName = this.impactAssessmentT6Filter.filterType;
    this.impactService.deleteImpactAssessmentT6(deleteItemModel).subscribe((data: any) => {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.result;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.selectedItems = [];
      this.authenticatedItems = [];
      this.updatedDbIds = [];
      this.fetchImpactAssessmentSummary();
    });
  }

  deleteImpactAssessment(): void {
    this.isLoading = true;
    const deleteItemModel = new DeleteItemModel();
    deleteItemModel.itemId = this.selectedItems;
    deleteItemModel.updatedDbId = this.updatedDbIds;
    deleteItemModel.screenName = this.impactAssessmentFilter.filterType;
    this.impactService.deleteImpactAssessment(deleteItemModel).subscribe((data: any) => {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.result;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.selectedItems = [];
      this.authenticatedItems = [];
      this.updatedDbIds = [];
      this.fetchImpactAssessmentSummary();
    });
  }

  alertMessage(): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    if (this.templateNo == 5) {
      //Have to do when Filter work will start at Impact Summery for
    }
    else {
      this.toastModel.Message = 'Please select at least one';
    }
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }

  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  removeFromBrowser(key: string): any {
    return localStorage.removeItem(key);
  }

  OnFilter(filter: ImpactAssessmentFilter): void {

    this.impactAssessmentFilter = filter;
    this.fetchImpactAssessmentSummary();
  }
  OnFilterT6(filter: ImpactAssessmentFilterT6): void {
    this.impactAssessmentT6Filter = filter;
    this.fetchImpactAssessmentSummary();
  }

  OnFilterT4(filter: ImpactAssessmentFilterT4): void {
    this.impactAssessmentT4Filter = filter;
    this.fetchImpactAssessmentSummary();
  }

  downloadReportT4(): void {
    if (this.selectedItems.length > 0) {
      this.isLoading = true;
      this.downloadReportModel.idList = this.selectedItems;
      const parsedUrl = new URL(window.location.href);
      this.downloadReportModel.currentUrl = parsedUrl.origin;
      this.impactService.downloadIAReports(this.downloadReportModel).subscribe(
        (data: any) => {
          this.isLoading = false;
          this.newIAItemId = 0;
          this.downloadReportModel = new DownloadReportModel();
          this.fetchImpactAssessmentSummary();
          // tslint:disable-next-line:one-variable-per-declaration
          const a = document.createElement('a'),
            fileURL = URL.createObjectURL(data);
          a.href = fileURL;
          a.download = `ImpactAssessmentReports.csv`;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.error(JSON.stringify(err.message));
        }
      );
    } else {
      this.alertMessage();
    }
  }

  downloadReport(): void {
    if (this.selectedItems.length > 0 && this.templateNo != 5) {
      this.isLoading = true;
      this.downloadReportModel.idList = this.selectedItems;
      const parsedUrl = new URL(window.location.href);
      this.downloadReportModel.currentUrl = parsedUrl.origin;
      this.impactService.downloadIAReports(this.downloadReportModel).subscribe(
        (data: any) => {
          this.isLoading = false;
          this.newIAItemId = 0;
          this.downloadReportModel = new DownloadReportModel();
          this.fetchImpactAssessmentSummary();
          // tslint:disable-next-line:one-variable-per-declaration
          const a = document.createElement('a'),
            fileURL = URL.createObjectURL(data);
          a.href = fileURL;
          a.download = `ImpactAssessmentReports.csv`;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.error(JSON.stringify(err.message));
        }
      );
    } else {
      this.alertMessage();
    }
  }

  bulkUpdate(): void {
    if (this.selectedItems.length > 0) {
      if (this.templateNo == 4) {
        if (this.selectedJuris != null) {
          let index = -1;
          let globalJurisdiction = localStorage.getItem('selectedDivisionName');
          index = this.selectedJuris.findIndex(a => a != globalJurisdiction);
          if (index > -1) {
            this.toastModel.Title = 'Warning';
            this.toastModel.Type = 'warning';
            this.toastModel.Message = 'Bulk Update only works on same division as selected Globally.';
            this.isToastShow = true;
            setTimeout(() => {
              this.isToastShow = false;
            }, 5000);
          }
          else {
            this.openBulkUpdateDialog();
          }
        }
      }
      else {
        this.openBulkUpdateDialog();
      }
    } else {
      this.alertMessage();
    }
  }

  openBulkUpdateDialog(): void {
    if (this.templateNo == 4) {
      const dialogRef = this.dialog.open(BulkUpdateT4DialogComponent, {
        width: '1800px',
        height: '850px'
      });
      dialogRef.afterClosed().subscribe((result:any) => {
        if (result) {
          this.addBulkUpdateT4(result);
        }
      });
    }
    else if (this.templateNo == 5) {
      const dialogRef = this.dialog.open(BulkUpdateDialogT5Component, {
        width: '1800px',
        height: '850px'
      });
      dialogRef.afterClosed().subscribe((result:any) => {
        if (result) {
          this.addBulkUpdateT5(result);
        }
      });
    }
    else {
      const dialogRef = this.dialog.open(BulkUpdateDialogComponent, {
        width: '1800px',
        height: '850px',
        data: this.templateNo
      });
      dialogRef.afterClosed().subscribe((result:any) => {
        if (result) {
          this.addBulkUpdate(result);
        }
      });
    }
  }

  addBulkUpdate(iaDetails: ImpactAssessment): void {
    this.bulkUpdateModel.itemIds = this.selectedItems;
    this.bulkUpdateModel.impactAssessment = iaDetails;
    this.impactService.iABulkUpdate(this.bulkUpdateModel).subscribe((data: any) => {
      //this.selectedItems = [];
      this.authenticatedItems = [];
      this.bulkUpdateModel = new BulkUpdateModel();
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Bulk update successfully';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.fetchImpactAssessmentSummary();
    });
  }

  addBulkUpdateT4(iaDetails: ImpactAssessment4): void {
    this.bulkUpdateT4Model.itemIds = this.selectedItems;
    this.bulkUpdateT4Model.impactAssessment = iaDetails;
    this.impactService.iABulkUpdateT4(this.bulkUpdateT4Model).subscribe((data: any) => {
      //this.selectedItems = [];
      this.authenticatedItems = [];
      this.bulkUpdateT4Model = new BulkUpdateT4Model();
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Bulk update successfully';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.fetchImpactAssessmentSummary();
    });
  }

  duplicateImpactAssessment(id: number): void {
    this.isLoading = true;
    this.impactService.DuplicateImpactAssessment(id).subscribe((data: any) => {
      this.bulkUpdateModel = new BulkUpdateModel();
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.result;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.fetchImpactAssessmentSummary();
    });
  }
  duplicateImpactAssessmentT6(id: number): void {
    this.isLoading = true;
    this.impactService.DuplicateImpactAssessmentT6(id).subscribe((data: any) => {
      this.bulkUpdateModel = new BulkUpdateModel();
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.result;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.fetchImpactAssessmentSummary();
    });
  }

  showHideColumn(item: string, itemWidth: number, isHide: boolean, filter: string): void {

    switch (item) {

      case 'Regulator':
        this.impactAssessmentColumns.regulator = isHide;
        break;
      case 'Title':
        this.impactAssessmentColumns.title = isHide;
        break;
      case 'Topic':
        this.impactAssessmentColumns.ruleTopic = isHide;
        break;
      case 'Publish Date':
        this.impactAssessmentColumns.publishDate = isHide;
        break;

      case 'Rule Type':
        this.impactAssessmentColumns.ruleType = isHide;
        break;
      case 'Effective Date':
        this.impactAssessmentColumns.applicationDate = isHide;
        break;
      case 'Legal Entity':
        this.impactAssessmentColumns.legalEntity = isHide;
        break;
      case 'Jurisdiction':
        this.impactAssessmentColumns.jurisdiction = isHide;
        break;
      case 'Impact Rating':
        this.impactAssessmentColumns.impactRating = isHide;
        break;
      case 'Implementation Type':
        this.impactAssessmentColumns.implementationType = isHide;
        break;
      case 'Assessment Team':
        this.impactAssessmentColumns.assessmentTeam = isHide;
        break;
      case 'Assessor':
        this.impactAssessmentColumns.assessor = isHide;
        break;
      case 'Review Team':
        this.impactAssessmentColumns.reviewTeam = isHide;
        break;
      case 'Reviewer':
        this.impactAssessmentColumns.reviewer = isHide;
        break;
      case 'Implementation Team':
        this.impactAssessmentColumns.implementationTeam = isHide;
        break;
      case 'Implementation Owner':
        this.impactAssessmentColumns.implementationOwner = isHide;
        break;
      case 'Assessment Status':
        this.impactAssessmentColumns.assessmentStatus = isHide;
        break;
      case 'Next Action Date':
        this.impactAssessmentColumns.assessmentDueDate = isHide;
        break;
      case 'Review Status':
        this.impactAssessmentColumns.reviewStatus = isHide;
        break;
      case 'Review Due Date':
        this.impactAssessmentColumns.reviewDueDate = isHide;
        break;
      case 'Implementation Status':
        this.impactAssessmentColumns.implementationStatus = isHide;
        break;
      case 'Implementation Due Date':
        this.impactAssessmentColumns.implementationDueDate = isHide;
        break;
    }

    // if (filter === 'Change') {
    //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    // } else if (!isHide) {
    //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    // }
    //this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');

    if (filter === 'Change') {
      if (isHide) {
        this.tableWidth = this.tableWidth + itemWidth;
        this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');

      }
      else if (!isHide) {
        this.tableWidth = this.tableWidth - itemWidth;
        this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
      }
    }
    MasterHelper.saveOnBrowser(this.assesmentType, JSON.stringify(this.itemActiveModel));
  }
  showHideColumnT6(item: string, itemWidth: number, isHide: boolean, filter: string): void {

    switch (item) {

      case 'Regulator':
        this.impactAssessmentT6Columns.regulator = isHide;
        break;
      case 'Title':
        this.impactAssessmentT6Columns.title = isHide;
        break;
      case 'Topic':
        this.impactAssessmentT6Columns.ruleTopic = isHide;
        break;
      case 'Publish Date':
        this.impactAssessmentT6Columns.publishDate = isHide;
        break;

      case 'Rule Type':
        this.impactAssessmentT6Columns.ruleType = isHide;
        break;
      case 'Effective Date':
        this.impactAssessmentT6Columns.applicationDate = isHide;
        break;
      case 'Legal Entity':
        this.impactAssessmentT6Columns.legalEntity = isHide;
        break;
      case 'Jurisdiction':
        this.impactAssessmentT6Columns.jurisdiction = isHide;
        break;
      case 'Impact Rating':
        this.impactAssessmentT6Columns.impactRating = isHide;
        break;
      case 'Implementation Type':
        this.impactAssessmentT6Columns.implementationType = isHide;
        break;
      case 'Assessment Team':
        this.impactAssessmentT6Columns.assessmentTeam = isHide;
        break;
      case 'Assessor':
        this.impactAssessmentT6Columns.assessor = isHide;
        break;
      case 'Review Team':
        this.impactAssessmentT6Columns.reviewTeam = isHide;
        break;
      case 'Reviewer':
        this.impactAssessmentT6Columns.reviewer = isHide;
        break;
      case 'Implementation Team':
        this.impactAssessmentT6Columns.implementationTeam = isHide;
        break;
      case 'Implementation Owner':
        this.impactAssessmentT6Columns.implementationOwner = isHide;
        break;
      case 'Assessment Status':
        this.impactAssessmentT6Columns.assessmentStatus = isHide;
        break;
      case 'Next Action Date':
        this.impactAssessmentT6Columns.assessmentDueDate = isHide;
        break;
      case 'Review Status':
        this.impactAssessmentT6Columns.reviewStatus = isHide;
        break;
      case 'Review Due Date':
        this.impactAssessmentT6Columns.reviewDueDate = isHide;
        break;
      case 'Implementation Status':
        this.impactAssessmentT6Columns.implementationStatus = isHide;
        break;
      case 'Implementation Due Date':
        this.impactAssessmentT6Columns.implementationDueDate = isHide;
        break;
    }

    // if (filter === 'Change') {
    //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    // } else if (!isHide) {
    //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    // }
    //this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');

    if (filter === 'Change') {
      if (isHide) {
        this.tableWidth = this.tableWidth + itemWidth;
        this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');

      }
      else if (!isHide) {
        this.tableWidth = this.tableWidth - itemWidth;
        this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
      }
    }
    MasterHelper.saveOnBrowser(this.assesmentType, JSON.stringify(this.itemActiveT6Model));
  }


  //Template 4 Functions

  sortImpactAssessmentT4(key: string): void {
    this.impactAssessmentT4Filter.IsDesc = !this.impactAssessmentT4Filter.IsDesc;
    this.impactAssessmentT4Filter.SortKey = key;
    this.fetchImpactAssessmentSummary();
  }

  checkIAT4UserAuth(item: ImpactAssessmentT4ListDto): boolean {
    const allUsers = item.assessor ? item.assessor : '';

    if (allUsers) {
      const userArr = allUsers.split(',');
      return userArr.some(a => (a && a.toLowerCase()) === this.userAccessToken.fullName.toLowerCase());
    } else {
      return false;
    }
  }

  deleteImpactAssessmentT4(): void {
    this.isLoading = true;
    const deleteItemModel = new DeleteItemModel();
    deleteItemModel.itemId = this.selectedItems;
    deleteItemModel.updatedDbId = this.updatedDbIds;
    deleteItemModel.screenName = this.impactAssessmentT4Filter.filterType;
    this.impactService.deleteImpactAssessmentT4(deleteItemModel).subscribe((data: any) => {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.result;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.selectedItems = [];
      this.authenticatedItems = [];
      this.updatedDbIds = [];
      this.fetchImpactAssessmentSummary();
    });
  }

  duplicateImpactAssessmentT4(id: number): void {
    this.isLoading = true;
    this.impactService.duplicateImpactAssessmentT4(id).subscribe((data: any) => {
      this.bulkUpdateT4Model = new BulkUpdateT4Model();
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.result;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.fetchImpactAssessmentSummary();
    });
  }

  showHideColumnT4(item: string, itemWidth: number, isHide: boolean, filter: string): void {
    switch (item) {
      case 'Regulator':
        this.impactAssessmentT4Columns.regulator = isHide;
        break;
      case 'Title':
        this.impactAssessmentT4Columns.title = isHide;
        break;
      case 'Topic':
        this.impactAssessmentT4Columns.ruleTopic = isHide;
        break;
      case 'Publish Date':
        this.impactAssessmentT4Columns.publishDate = isHide;
        break;
      case 'Rule Type':
        this.impactAssessmentT4Columns.ruleType = isHide;
        break;
      case 'Effective Date':
        this.impactAssessmentT4Columns.applicationDate = isHide;
        break;
      case 'Last Update':
        this.impactAssessmentT4Columns.lastUpdate = isHide;
        break;
      case 'Jurisdiction':
        this.impactAssessmentT4Columns.jurisdiction = isHide;
        break;
      case 'Assessor':
        this.impactAssessmentT4Columns.assessor = isHide;
        break;
      case 'Assessment Status':
        this.impactAssessmentT4Columns.assessmentStatus = isHide;
        break;
    }

    // if (filter === 'Change') {
    //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    // } else if (!isHide) {
    //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    // }
    //this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');

    if (filter === 'Change') {
      if (isHide) {
        this.tableWidth = this.tableWidth + itemWidth;
        this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
      }
      else if (!isHide) {
        this.tableWidth = this.tableWidth - itemWidth;
        this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
      }
    }
    MasterHelper.saveOnBrowser(this.assesmentType, JSON.stringify(this.itemActiveModelT4));
  }

  //Template 5 Functions
  sortImpactAssessmentT5(key: string): void {
    this.impactAssessmentT5Filter.IsDesc = !this.impactAssessmentT5Filter.IsDesc;
    this.impactAssessmentT5Filter.SortKey = key;
    this.fetchImpactAssessmentSummary();
  }

  showHideColumnT5(item: string, itemWidth: number, isHide: boolean, filter: string): void {
    switch (item) {
      case 'Regulator':
        this.impactAssessmentT5Columns.regulator = isHide;
        break;
      case 'Title':
        this.impactAssessmentT5Columns.title = isHide;
        break;
      case 'Topic':
        this.impactAssessmentT5Columns.ruleTopic = isHide;
        break;
      case 'Team':
        this.impactAssessmentT5Columns.team = isHide;
        break;
      case 'Rule Type':
        this.impactAssessmentT5Columns.ruleType = isHide;
        break;
      case 'Effective Date':
        this.impactAssessmentT5Columns.effectiveDate = isHide;
        break;
      case 'Response Lead':
        this.impactAssessmentT5Columns.responseLead = isHide;
        break;
      case 'Jurisdiction':
        this.impactAssessmentT5Columns.jurisdiction = isHide;
        break;
      case 'Accountable Executive':
        this.impactAssessmentT5Columns.accountableExecutive = isHide;
        break;
      case 'Rag Rating':
        this.impactAssessmentT5Columns.rAGRating = isHide;
        break;
      case 'Response Deadline':
        this.impactAssessmentT5Columns.resposeDeadline = isHide;
        break;
      case 'Consultation Period':
        this.impactAssessmentT5Columns.consultationPeriod = isHide;
        break;
      case 'Did We Respond':
        this.impactAssessmentT5Columns.didWeRespond = isHide;
        break;
      case 'Response Appraoch':
        this.impactAssessmentT5Columns.responseAppraoch = isHide;
        break;
      case 'Report Submission Date':
        this.impactAssessmentT5Columns.reportSubmissionDate = isHide;
        break;
      case 'Extension Requested':
        this.impactAssessmentT5Columns.extensionRequested = isHide;
        break;
      case 'Current Status':
        this.impactAssessmentT5Columns.currentStatus = isHide;
        break;
      case 'Next Action Date':
        this.impactAssessmentT5Columns.nextActionDate = isHide;
        break;
      case 'Next Action Step':
        this.impactAssessmentT5Columns.nextActionStep = isHide;
        break;
      case 'Engagement Plan':
        this.impactAssessmentT5Columns.engagementPlan = isHide;
        break;
      case 'Policy Response Achieved':
        this.impactAssessmentT5Columns.policyResponseAchieved = isHide;
        break;
      case 'No. of Key Messages':
        this.impactAssessmentT5Columns.numberofKeyMessages = isHide;
        break;
      case 'Key Messages Acheived':
        this.impactAssessmentT5Columns.keyMessagesAcheived = isHide;
        break;
    }

    // if (filter === 'Change') {
    //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    // } else if (!isHide) {
    //   this.tableWidth = isHide ? this.tableWidth + itemWidth : this.tableWidth - itemWidth;
    // }
    //this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');

    if (filter === 'Change') {
      if (isHide) {
        this.tableWidth = this.tableWidth + itemWidth;
        this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
        const bodyStyleElement = document.querySelector('.body-style5') as HTMLDivElement;
        const tableElement = document.querySelector('.table') as HTMLDivElement;

        // Check if the elements exist
        if (bodyStyleElement && tableElement) {
          // Set the width for .body-style and .table
          bodyStyleElement.style.width = this.tableWidth + 'px';
          tableElement.style.width = this.tableWidth + 'px';
          bodyStyleElement.style.overflow = 'auto';
        }
      }
      else if (!isHide) {
        this.tableWidth = this.tableWidth - itemWidth;
        this.eleRef.nativeElement.style.setProperty('--table-min-width', this.tableWidth + 'px');
        const bodyStyleElement = document.querySelector('.body-style5') as HTMLDivElement;
        const tableElement = document.querySelector('.table') as HTMLDivElement;

        // Check if the elements exist
        if (bodyStyleElement && tableElement) {
          // Set the width for .body-style and .table
          bodyStyleElement.style.width = this.tableWidth + 'px';
          tableElement.style.width = this.tableWidth + 'px';
          bodyStyleElement.style.overflow = 'auto';
        }
      }
    }
    MasterHelper.saveOnBrowser(this.assesmentType, JSON.stringify(this.itemActiveModelT5));
  }
  duplicateImpactAssessmentT5(id: number): void {
    this.isLoading = true;
    this.impactService.duplicateImpactAssessmentT5(id).subscribe((data: any) => {
      this.bulkUpdateT5Model = new BulkUpdateT5Model();
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.result;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.fetchImpactAssessmentSummary();
    });
  }
  checkIAT5UserAuth(item: ImpactAssessmentT5): boolean {
    const allUsers = item.responseLead ? item.responseLead : '' + ',' + item.accountableExecutive ? item.accountableExecutive : '';

    if (allUsers) {
      const userArr = allUsers.split(',');
      return userArr.some(a => (a && a.toLowerCase()) === this.userAccessToken.fullName.toLowerCase());
    } else {
      return false;
    }
  }
  addBulkUpdateT5(iaDetails: ImpactAssessmentT5): void {
    this.bulkUpdateT5Model.itemIds = this.selectedItems;
    this.bulkUpdateT5Model.impactAssessment = iaDetails;
    this.impactService.iABulkUpdateT5(this.bulkUpdateT5Model).subscribe((data: any) => {
      //this.selectedItems = [];
      this.authenticatedItems = [];
      this.bulkUpdateT4Model = new BulkUpdateT4Model();
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = 'Bulk update successfully';
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.fetchImpactAssessmentSummary();
    });
  }
  deleteImpactAssessmentT5(): void {
    this.isLoading = true;
    const deleteItemModel = new DeleteItemModel();
    deleteItemModel.itemId = this.selectedItems;
    deleteItemModel.updatedDbId = this.updatedDbIds;
    deleteItemModel.screenName = this.impactAssessmentT5Filter.filterType;
    this.impactService.deleteImpactAssessmentT5(deleteItemModel).subscribe((data: any) => {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
      this.toastModel.Message = data.result;
      this.isToastShow = true;
      setTimeout(() => {
        this.isToastShow = false;
      }, 5000);
      this.selectedItems = [];
      this.authenticatedItems = [];
      this.updatedDbIds = [];
      this.fetchImpactAssessmentSummary();
    });
  }
  OnFilterT5(filter: ImpactAssessmentT5Filter): void {
    this.impactAssessmentT5Filter = filter;
    this.fetchImpactAssessmentSummary();
  }
  downloadReportT5(): void {
    if (this.selectedItems.length > 0) {
      this.isLoading = true;
      this.downloadReportModel.idList = this.selectedItems;
      const parsedUrl = new URL(window.location.href);
      this.downloadReportModel.currentUrl = parsedUrl.origin;
      this.impactService.downloadIAReports(this.downloadReportModel).subscribe(
        (data: any) => {
          this.isLoading = false;
          this.newIAItemId = 0;
          this.downloadReportModel = new DownloadReportModel();
          this.fetchImpactAssessmentSummary();
          // tslint:disable-next-line:one-variable-per-declaration
          const a = document.createElement('a'),
            fileURL = URL.createObjectURL(data);
          a.href = fileURL;
          a.download = `ImpactAssessmentReports.csv`;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.error(JSON.stringify(err.message));
        }
      );
    } else {
      this.alertMessage();
    }
  }
  allSelectedItems(event: any, dataList: any) {
    this.selectedItems = this._globalService.allSelectedItems(event, dataList);
  }
  filterPersistenceKeyT5 = 'impactAssessmentT5Filters';
  saveOnBrowser(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
  redirectLink(templateNo: number, id: number) {
    let link = '/impact-assessment/details/impact/'+templateNo+'/' + id + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
    this.router.navigate([link], navigationExtras);
  }
  getIdList(): number[] {
    return this.impactAssessmentSummary.map(item => item.id);
  }
  getT4IdList(): number[] {
    return this.impactAssessmentT4Summary.map(item => item.id);
  }
  getT5IdList(): number[] {
    return this.impactAssessmentT5Summary.map(item => item.id);
  }
  getT6IdList(): number[] {
    return this.impactAssessmentT6Summary.map(item => item.id);
  }
}
